export default "/_next/static/chunks/fonts/Roboto-Italic-latin-08055fc3afa2ffe04a7a860a0dbabf50.woff2";